import ResourcesPage from "./resources";

export default ResourcesPage;
